var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-alert',{attrs:{"value":_vm.open,"message":_vm.alert_message,"color":_vm.alert_color,"icon":_vm.alert_icon,"title":_vm.alert_title,"action":_vm.action,"actionLabel":_vm.action_label},on:{"close":_vm.closeAlert},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }